import { all } from "redux-saga/effects";
import altAssets from "./alt-assets/saga";
import assetAuditors from "./asset-auditors/saga";
import assetSync from "./asset-sync/saga";
import auditAssets from "./audit-assets/saga";
import auditAssignments from "./audit-assignments/saga";
import auditDownload from "./audit-download/saga";
import auditUpload from "./audit-upload/saga";
import appSupport from "./app-support/saga";
import audits from "./audits/saga";
import auth from "./auth/saga";
import geoLocation from "./geo-location/saga";
import organisation from "./organisation/saga";
import typesList from "./types-list/saga";
import search from "./search/saga";
import app from "./app/saga";
import debugState from "./debug-state/saga";
import userLanguage from "./user-langauge/saga";

/**
 * Root Saga
 */
export default function* () {
    yield all([
        altAssets,
        assetAuditors,
        assetSync,
        auditAssets,
        auditAssignments,
        auditDownload,
        auditUpload,
        appSupport,
        audits,
        auth,
        geoLocation,
        organisation,
        typesList,
        search,
        app,
        debugState,
        userLanguage,
    ]);
}
